import { Injectable, NgZone, Directive, ElementRef, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MalihuScrollbarService = /** @class */ (function () {
    function MalihuScrollbarService(zone) {
        this.zone = zone;
    }
    /**
     * @param {?} element
     * @param {?} options
     * @return {?}
     */
    MalihuScrollbarService.prototype.initScrollbar = /**
     * @param {?} element
     * @param {?} options
     * @return {?}
     */
    function (element, options) {
        /** @type {?} */
        var jQueryElement = this.getElement(element);
        this.zone.runOutsideAngular(function () { return jQueryElement.mCustomScrollbar(options); });
        if (jQueryElement.length > 0 && jQueryElement[0].tagName === 'BODY') {
            jQueryElement[0].style.position = 'absolute';
            jQueryElement[0].style.overflow = 'auto';
            jQueryElement[0].style.height = '100vh';
            jQueryElement[0].style.width = '100vw';
        }
    };
    /**
     * @param {?} element
     * @param {?} parameter
     * @param {?} options
     * @return {?}
     */
    MalihuScrollbarService.prototype.scrollTo = /**
     * @param {?} element
     * @param {?} parameter
     * @param {?} options
     * @return {?}
     */
    function (element, parameter, options) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('scrollTo', parameter, options); });
    };
    /**
     * @param {?} element
     * @return {?}
     */
    MalihuScrollbarService.prototype.update = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('update'); });
    };
    /**
     * @param {?} element
     * @return {?}
     */
    MalihuScrollbarService.prototype.stop = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('stop'); });
    };
    /**
     * @param {?} element
     * @param {?=} reset
     * @return {?}
     */
    MalihuScrollbarService.prototype.disable = /**
     * @param {?} element
     * @param {?=} reset
     * @return {?}
     */
    function (element, reset) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('disable', !!reset); });
    };
    /**
     * @param {?} element
     * @return {?}
     */
    MalihuScrollbarService.prototype.destroy = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('destroy'); });
    };
    /**
     * @param {?} element
     * @return {?}
     */
    MalihuScrollbarService.prototype.getElement = /**
     * @param {?} element
     * @return {?}
     */
    function (element) {
        if (typeof element === 'string') {
            return $(element);
        }
        if (typeof element === 'object' && element instanceof HTMLElement) {
            return $(element);
        }
        if (element instanceof jQuery || 'jquery' in Object(element)) {
            return element;
        }
        throw Error("Unsupported element type in MalihuScrollbarService: " + element);
    };
    MalihuScrollbarService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    MalihuScrollbarService.ctorParameters = function () { return [
        { type: NgZone }
    ]; };
    return MalihuScrollbarService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Malihu Custom Scrollbar directive
 * Use this reference link for options definition
 * http://manos.malihu.gr/jquery-custom-content-scroller/
 */
var MalihuScrollbarDirective = /** @class */ (function () {
    function MalihuScrollbarDirective(elementRef, mScrollbarService) {
        this.elementRef = elementRef;
        this.mScrollbarService = mScrollbarService;
    }
    /**
     * @return {?}
     */
    MalihuScrollbarDirective.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.initElements();
        this.initScrollbar();
    };
    /**
     * @return {?}
     */
    MalihuScrollbarDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.destroyScrollbar();
    };
    /**
     * @return {?}
     */
    MalihuScrollbarDirective.prototype.initElements = /**
     * @return {?}
     */
    function () {
        this.scrollableElement = !!this.scrollElementId
            ? $("#" + this.scrollElementId)
            : $(this.elementRef.nativeElement);
        if (!!this.scrollElementId && this.scrollableElement.length === 0) {
            console.error("MalihuScrollbarDirective cannot find element with provided scrollElementId: " + this.scrollElementId + ".");
        }
    };
    /**
     * @return {?}
     */
    MalihuScrollbarDirective.prototype.initScrollbar = /**
     * @return {?}
     */
    function () {
        this.mScrollbarService.initScrollbar(this.scrollableElement, this.scrollbarOptions);
    };
    /**
     * @return {?}
     */
    MalihuScrollbarDirective.prototype.destroyScrollbar = /**
     * @return {?}
     */
    function () {
        try {
            this.mScrollbarService.destroy(this.scrollableElement);
        }
        catch (error) {
            // workaround for malihu-custom-scrollbar-plugin issue:
            // Cannot read property 'autoUpdate' of undefined
            // https://github.com/malihu/malihu-custom-scrollbar-plugin/issues/392
        }
    };
    MalihuScrollbarDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[MalihuScrollbar], [malihu-scrollbar]',
                },] },
    ];
    /** @nocollapse */
    MalihuScrollbarDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: MalihuScrollbarService }
    ]; };
    MalihuScrollbarDirective.propDecorators = {
        scrollElementId: [{ type: Input }],
        scrollbarOptions: [{ type: Input }]
    };
    return MalihuScrollbarDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var MalihuScrollbarModule = /** @class */ (function () {
    function MalihuScrollbarModule() {
    }
    /**
     * @return {?}
     */
    MalihuScrollbarModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: MalihuScrollbarModule,
            providers: [MalihuScrollbarService],
        };
    };
    /**
     * @return {?}
     */
    MalihuScrollbarModule.forChild = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: MalihuScrollbarModule,
        };
    };
    MalihuScrollbarModule.decorators = [
        { type: NgModule, args: [{
                    exports: [MalihuScrollbarDirective],
                    declarations: [MalihuScrollbarDirective],
                },] },
    ];
    return MalihuScrollbarModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { MalihuScrollbarService, MalihuScrollbarDirective, MalihuScrollbarModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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